var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.728 32.728A18 18 0 117.272 7.273a18 18 0 0125.456 25.455zM22.3 12.897c0-.797-.468-1.48-1.091-1.881l-.008-.005c-.686-.412-1.562-.418-2.22.002-.677.408-1.095 1.097-1.095 1.884 0 .823.415 1.514 1.095 1.923.658.42 1.534.415 2.22.003l.008-.005c.627-.403 1.091-1.087 1.091-1.921zm-5.029 4.15a1.58 1.58 0 00-1.571 1.57c0 .881.69 1.572 1.571 1.572h1.53v5.968h-2.03A1.58 1.58 0 0015.2 27.73c0 .88.69 1.571 1.571 1.571h6.958a1.58 1.58 0 001.571-1.571c0-.841-.73-1.572-1.571-1.572h-1.785v-7.54c0-.84-.73-1.57-1.572-1.57h-3.1z"
  })));
}
export default SvgInfoCircle;